// extracted by mini-css-extract-plugin
export default {"list":"UserSelectionModal_list__pcWV6"};